import { Frequency } from '../models/frequency.model';

export const frequencyOrder = {
  [Frequency.SixPerWeek]: 8,
  [Frequency.FivePerWeek]: 7,
  [Frequency.FourPerWeek]: 6,
  [Frequency.ThreePerWeek]: 5,
  [Frequency.TwoPerWeek]: 4,
  [Frequency.Weekly]: 3,
  [Frequency.EOW]: 2,
  [Frequency.Monthly]: 1,
};
